document.addEventListener("DOMContentLoaded", function () {
  console.log("variant-swatch.js çalışıyor");

  document.body.addEventListener("click", function (e) {
    const swatch = e.target.closest(".image-swatch-wrapper");
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    const newImage = swatch.getAttribute("data-variant-image");
    if (!newImage) return;

    const productCard = swatch.closest("product-card");
    if (!productCard) {
      console.log("product-card bulunamadı");
      return;
    }

    const mainImage = productCard.querySelector("img");
    if (!mainImage) {
      console.log("Ana görsel bulunamadı");
      return;
    }

    mainImage.src = newImage;
    mainImage.srcset = newImage;

    console.log("Kart görseli değiştirildi:", newImage);
  });
});
